module.exports = __webpack_public_path__ + "img/IMG_1444_L.1a70ee9b.webp";